var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88726 11.7764C4.66504 11.7764 3.66504 12.7764 3.66504 13.9986C3.66504 15.2208 4.66504 16.2208 5.88726 16.2208C7.10948 16.2208 8.10948 15.2208 8.10948 13.9986C8.10948 12.7764 7.10948 11.7764 5.88726 11.7764Z",
    fill: "#141522",
    stroke: "#141522",
    strokeWidth: 1.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4439 11.7764C20.2217 11.7764 19.2217 12.7764 19.2217 13.9986C19.2217 15.2208 20.2217 16.2208 21.4439 16.2208C22.6661 16.2208 23.6661 15.2208 23.6661 13.9986C23.6661 12.7764 22.6661 11.7764 21.4439 11.7764Z",
    fill: "#141522",
    stroke: "#141522",
    strokeWidth: 1.33333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6646 11.7764C12.4424 11.7764 11.4424 12.7764 11.4424 13.9986C11.4424 15.2208 12.4424 16.2208 13.6646 16.2208C14.8868 16.2208 15.8868 15.2208 15.8868 13.9986C15.8868 12.7764 14.8868 11.7764 13.6646 11.7764Z",
    fill: "#141522",
    stroke: "#141522",
    strokeWidth: 1.33333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/More_icon.accb57a6017c843de62561637f796e04.svg";
export { ForwardRef as ReactComponent };